import React, { useMemo } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";

import { RecentLeadStatusDisplayContent } from "../RecentLeadStatusContent";

type TooltipProps = {
  id?: string;
  status: string;
  children: React.ReactNode;
  trackTooltipHover?: () => void;
};

//TODO: fix default styles for tooltip white
export const RecentLeadsStatusTooltip: React.FC<TooltipProps> = ({
  id,
  status,
  children,
  trackTooltipHover,
}) => {
  const uniqueId = useMemo(
    () => (id ? id : `tooltip-${Math.random().toString(36).slice(2, 9)}`),
    [id],
  );

  return (
    <>
      <div
        data-testid="ui-tooltip"
        className="relative inline-block cursor-pointer"
        data-tooltip-id={uniqueId + "-" + status}
        onMouseEnter={() => {
          trackTooltipHover?.();
        }}
      >
        {children}
      </div>

      <ReactTooltip
        id={uniqueId + "-" + status}
        place="bottom"
        className="z-50 !w-[256px] !rounded-lg !bg-surface-primary !p-4 text-left font-body !text-sm font-normal leading-normal !opacity-100 shadow-lg shadow-stroke-primary !transition-opacity rtl:text-right"
        opacity={1}
        delayShow={200}
        delayHide={0}
      >
        <RecentLeadStatusDisplayContent status={status} />
      </ReactTooltip>
    </>
  );
};
